import React, {useEffect, useRef} from "react";
import PropTypes from "prop-types";
import ReactSlick from "react-slick";
import "./slick.css";
import "./slick-theme.css";
import "./Carousel.pcss";

const Carousel = (props) => {
    const ref = useRef();

    // work around to hide non active slide to enforce aria rule.
    // Refer react-slick issue: https://github.com/akiran/react-slick/issues/1535#issuecomment-877776983
    // Tradeoff: this is affecting carousel behavior; there's a blank screen in between transitions.
    // Ref: https://user-images.githubusercontent.com/41619036/188971154-d0a38a1b-b511-47fe-91b8-8f84b3166452.mp4
    const changeCardVisibility = () => {
        if (ref.current) {
            Array.from(document.querySelectorAll(".slick-slide")).forEach((slide) => {
                slide.style.visibility = slide.classList?.contains("slick-active")
                    ? "visible"
                    : "hidden";
            });
        }
    };

    useEffect(() => {
        changeCardVisibility();
    });

    return (
        <ReactSlick
            ref={ref}
            dots={props.dots}
            arrows={props.arrows}
            rows={props.rows}
            autoplay={props.autoplay}
            infinite={props.infinite}
            speed={props.speed}
            slidesToShow={props.slidesToShow}
            slidesToScroll={props.slidesToScroll}
            easing="ease"
            responsive={props.responsive}
            className={props.className}
            afterChange={changeCardVisibility}
        >
            {props.children}
        </ReactSlick>
    );
};
Carousel.propTypes = {
    dots: PropTypes.bool,
    infinite: PropTypes.bool,
    speed: PropTypes.number,
    slidesToShow: PropTypes.number,
    slidesToScroll: PropTypes.number,
    responsive: PropTypes.arrayOf(
        PropTypes.shape({
            breakpoint: PropTypes.number.isRequired,
            settings: PropTypes.shape({}).isRequired,
        }),
    ),
};

Carousel.defaultProps = {
    dots: true,
    arrows: true,
    rows: 1,
    autoplay: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
};

export default Carousel;
